"use client";

import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';
import { useSession, signIn, signOut } from "next-auth/react";
import { FunctionComponent } from "react";
import { useAuthContext } from 'src/auth/hooks';

import { paths } from 'src/routes/paths';

const AuthButton: FunctionComponent = () => {
  const theme = useTheme();
  const isLight = theme.palette.mode === 'light';
  const { login, logout } = useAuthContext();
  const { data: session } = useSession();
  let loggedIn = false;
  session && session.user && (loggedIn = true);

  return (
    <Button
      variant="contained"
      rel="noopener"
      href={`#${loggedIn ? "logged-in" : "logged-out"}`}
      onClick={() => (loggedIn ? logout() : signIn("whop", { callbackUrl: paths.dashboard.root }))}
      sx={{
        px: 3,
        py: 1,
        borderRadius: '8px',
        background: isLight ? theme.palette.grey[900] : '#ffffff',
        color: isLight ? '#ffffff' : theme.palette.grey[900],
        fontWeight: 600,
        fontSize: '0.875rem',
        textTransform: 'none',
        boxShadow: 'none',
        transition: 'all 0.2s ease',
        '&:hover': {
          background: isLight ? theme.palette.grey[800] : theme.palette.grey[200],
          boxShadow: 'none',
        },
      }}
    >
      {loggedIn ? "Sign out" : "Sign in"}
    </Button>
  );
};

export default AuthButton;
